import React from "react"
import styles from "@css/modules/Resort.module.scss"
import { useRouter } from "next/navigation"
import { OfferIllustration } from "@css/icons/SVG"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"
import { SlideAppear } from "../../Animation/SlideAppear"
import { Resort } from "@t/Resort"

export function Offer({ resort }: { resort: Resort }) {
    const router = useRouter()
    const isMobile = useMediaQuery("(max-width: 1023px)")
    if (!resort?.offer) {
        return null
    }
    const { buttonText, buttonLink, title, description } = resort?.offer
    const onClick = () => {
        if (buttonLink) {
            router.push(buttonLink)
        }
    }
    return (
        <SlideAppear className={styles.offerRoot}>
            <div className={styles.left}>
                <h3 className={styles.offerTitle}>{title}</h3>
                <div className={styles.offerDesc}>{description}</div>
                <button onClick={onClick} className={styles.button}>
                    {buttonText}
                </button>
            </div>
            {!isMobile && <OfferIllustration />}
        </SlideAppear>
    )
}
